import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  username: Yup.string()
    .trim()
    .email("The email address format you have entered is invalid")
    .required("Email address is required"),
  password: Yup.string().trim().required("Password is required"),
});
